<template>
    <div class="c-slider-wrapper">
        <div class="c-slider-normal swiper-container-plus-items">
            <img src="/src/assets/img/common/slider-arrow-prev-orange.png" alt="＜" class="slide-arrow prev-arrow">
            <div class="swiper-wrapper">
                <div class="swiper-slide c-slider-normal__item" v-for="(item, index) in items" :key="index">
                    <a :href="route(route_list, route_link_name, {id:item.id})">
                        <div class="c-slider-normal__img">
                            <webp-picture :webp="item.webp_thumbnail_url" class="inherit">
                                <img loading="lazy" :src="item.image_thumbnail_url" alt="">
                            </webp-picture>
                        </div>
                        <p class="c-bookname">{{ item.talent_names }}</p>
                        <p class="c-booktitle text-truncate2">{{ $filters.truncate(item.title, 21, "...") }}</p>
                        <div class="c-slider-normal__icon">
                            <div class="c-label-new" v-if="item.is_new">New</div>
                            <div class="c-label-limited">{{ label }}</div>
                        </div>
                    </a>
                </div>
            </div>
            <img src="/src/assets/img/common/slider-arrow-next-orange.png" alt="＞" class="slide-arrow next-arrow">
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper/bundle';
import moment from 'moment';
import routeMixin from '../../mixins/route.js';
export default {
    props: [
        'items',
        'route_list',
        'category',
        'route_link_name'
    ],
    mixins: [routeMixin],
    data () {
        return {
            isShow: true,
            swiper: null,
            swiperOptions: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 8,
                loop: false,
                pagination: false,
                allowTouchMove: true,
                breakpoints: {
                    767: {
                        slidesPerView: 4,
                        navigation: {
                            nextEl: '.slide-arrow.next-arrow',
                            prevEl: '.slide-arrow.prev-arrow',
                        },
                    },
                },
            },
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.swiper = new Swiper('.swiper-container-plus-items', this.swiperOptions);
        });
    },
    computed: {
        label: function () {
            return "＋" + this.category;
        },
    },
}
</script>

<style lang="scss" scoped>
    .swiper-container-plus-items {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        z-index: 1;

        @media (max-width:767px) {
            overflow: visible;
        }
    }

    @media screen and (min-width: 767px) {
        .c-slider-normal .prev-arrow {
            left: -8px;
        }
        .c-slider-normal .next-arrow {
            right: -8px;
        }
    }

    .c-booktitle {
        word-break: break-all;
    }
</style>
